module.exports = __webpack_public_path__ + "img/fiji-2017-2.129e5435.jpg";